import { Alert, GlobalStyles, Loading } from "#/atoms";
import {
  Outlet,
  Route,
  Routes,
} from "react-router-dom";

import { BigCalendarView } from "../BigCalendar";
import { CalendarView } from "../Calendar";
import { CustomerDetailsView } from "../CustomerDetails";
import { CustomerOrdersView } from "../CustomerOrder";
import { CustomerView } from "../Customer";
import { CustomersView } from "../Customers";
import { DashboardView } from "../Dashboard";
import { ExpiredVirtualToursView } from "../ExpiredVirtualTours";
import { FindOrdersView } from "../FindOrders";
import { GenerateInvoicesView } from "../GenerateInvoices";
import { InvoicesView } from "../Invoices";
import { LoginView } from "../Login";
import { MessagingView } from "../Messaging";
import OptionalAuth from "./OptionalAuth";
import { OrderCreateView } from "../Order-Create";
import { OrderCustomerView } from "../Order-Customer";
import { OrderFailureView } from "../Order-Failure";
import { OrderNewView } from "../Order-New";
import { OrderOuttakesView } from "../Order-Outtakes";
import { OrderSMSsView } from "../OrderSMSs";
import { OrderSuccessView } from "../Order-Success";
import { OrderTypesView } from "../OrderTypes";
import { OrderView } from "../Order";
import { OrderWorkerView } from "../Order-Worker";
import { OrdersReportView } from "../OrdersReport";
import { OrdersView } from "../Orders";
import { OuttakesChosenView } from "../OuttakesChosen";
import { PackagesView } from "../Packages";
import { PrivacyView } from "../Privacy";
import RequireAdmin from "./RequireAdmin";
import RequireAuth from "./RequireAuth";
import RequireWorker from "./RequireWorker";
import { SettingsView } from "../Settings";
import { SignupView } from "../Signup";
import { SignupWorkerView } from "../SignupWorker";
import { TidyGuideView } from "../TidyGuide";
import { UsersView } from "../Users";
import { WorkerDetailsView } from "../WorkerDetails";
import { WorkerInvoicesView } from "../WorkerInvoices";
import { WorkerOrderOffersView } from "../WorkerOrderOffers";
import { WorkersView } from "../Workers";
import { useApi } from "@/api";

const App = () => {
  const { errorMessage, loading, successMessage } = useApi();
  
  return (
    <>
      <GlobalStyles />
      {loading && <Loading />}
      {errorMessage && <Alert type="error">{errorMessage}</Alert>}
      {successMessage && <Alert type="success">{successMessage}</Alert>}
      <Routes>
        <Route
          path="/"
          element={<RequireAuth><DashboardView /></RequireAuth>}
        />
        <Route
          path="activate/token=:token/tokenid=:tokenid"
          element={<LoginView></LoginView>}
        />
        <Route
          path="worker-tasks"
          element={<RequireAuth><DashboardView /></RequireAuth>}
        />
        <Route
          path="order-find"
          element={<RequireAuth><FindOrdersView /></RequireAuth>}
        />
        <Route
          path="order-find/email=:email"
          element={<RequireAuth><FindOrdersView /></RequireAuth>}
        />
        <Route
          path="orders-unmaintained"
          element={<RequireAuth><OrdersView /></RequireAuth>}
        />
        <Route
          path="customer-orders"
          element={<RequireAuth><CustomerOrdersView /></RequireAuth>}
        />
        <Route
          path="packages/action=new-order"
          element={<RequireAuth><PackagesView /></RequireAuth>}
        />
        <Route
          path="order-create"
          element={<RequireAdmin><OrderCreateView /></RequireAdmin>}
        />
        <Route
          path="order-new/brid=:brid/pkgid=:pkgid"
          element={<RequireAuth><OrderNewView /></RequireAuth>}
        />
        <Route
          path="order-new/brid=:brid/pkgid=:pkgid/baseorderid=:baseorderid"
          element={<RequireAuth><OrderNewView /></RequireAuth>}
        />
        <Route
          path="order-view-backend/order=:order"
          element={<RequireAuth><OrderView /></RequireAuth>}
        />
        <Route
          path="order-view/order=:order"
          element={<RequireAuth><OrderCustomerView /></RequireAuth>}
        />
        <Route
          path="order-view-outtakes/order=:order"
          element={<RequireAuth><OrderOuttakesView /></RequireAuth>}
        />
        <Route
          path="order-view-worker/order=:order"
          element={<RequireWorker><OrderWorkerView /></RequireWorker>}
        />
        <Route
          path="order-types"
          element={<RequireAdmin><OrderTypesView /></RequireAdmin>}
        />
        <Route
          path="customer-find"
          element={<RequireAdmin><CustomersView /></RequireAdmin>}
        />
        <Route
          path="customer-create"
          element={<RequireAdmin><CustomerView /></RequireAdmin>}
        />
        <Route
          path="account-customer"
          element={<RequireAuth><CustomerDetailsView /></RequireAuth>}
        />
        <Route
          path="account-customer/id=:id"
          element={<RequireAuth><CustomerDetailsView /></RequireAuth>}
        />
        <Route
          path="account-customer/id=:id/cbId=:cbId"
          element={<RequireAuth><CustomerDetailsView /></RequireAuth>}
        />
        <Route
          path="generate-invoices"
          element={<RequireAdmin><GenerateInvoicesView /></RequireAdmin>}
        />
        <Route
          path="invoices-find"
          element={<RequireAuth><InvoicesView /></RequireAuth>}
        />
        <Route index
          element={<RequireAuth><DashboardView /></RequireAuth>}
        />
        <Route
          path="users"
          element={<RequireAdmin><UsersView /></RequireAdmin>}
        />
        <Route
          path="workers"
          element={<RequireAdmin><WorkersView /></RequireAdmin>}
        />
        <Route
          path="account-worker"
          element={<RequireAuth><WorkerDetailsView /></RequireAuth>}
        />
        <Route
          path="account-worker/id=:id"
          element={<RequireAuth><WorkerDetailsView /></RequireAuth>}
        />
        <Route
          path="settings"
          element={<RequireAdmin><SettingsView /></RequireAdmin>}
        />
        <Route
          path="messaging"
          element={<RequireAdmin><MessagingView /></RequireAdmin>}
        />
        <Route
          path="login"
          element={<LoginView />}
        />
        <Route
          path="register"
          element={<SignupView />}
        />
        <Route
          path="register-worker"
          element={<SignupWorkerView />}
        />
        <Route
          path="expired-virtual-tours"
          element={<RequireAuth><ExpiredVirtualToursView /></RequireAuth>}
        />
        <Route
          path="orders-notifications"
          element={<RequireAuth><OrderSMSsView /></RequireAuth>}
        />
        <Route
          path="orders-outtakes"
          element={<RequireAuth><OuttakesChosenView /></RequireAuth>}
        />
        <Route
          path="orders-report"
          element={<RequireAuth><OrdersReportView /></RequireAuth>}
        />
        <Route
          path="worker-calendar"
          element={<RequireAuth><CalendarView /></RequireAuth>}
        />
        <Route
          path="privacy"
          element={<OptionalAuth><PrivacyView /></OptionalAuth>}
        />
        <Route
          path="tidy-guide"
          element={<OptionalAuth><TidyGuideView /></OptionalAuth>}
        />
        <Route
          path="admin-calendar"
          element={<RequireAuth><BigCalendarView /></RequireAuth>}
        />
        <Route
          path="worker-invoices"
          element={<RequireAuth><WorkerInvoicesView /></RequireAuth>}
        />
        <Route
          path="worker-order-offers"
          element={<RequireAuth><WorkerOrderOffersView /></RequireAuth>}
        />
        <Route
          path="order-accept/token=:token"
          element={<TidyGuideView />}
        />
        <Route
          path="order-reject/token=:token"
          element={<TidyGuideView />}
        />
        <Route
          path="order-failure/order=:order"
          element={<OptionalAuth><OrderFailureView /></OptionalAuth>}
        />
        <Route
          path="order-success/order=:order"
          element={<OptionalAuth><OrderSuccessView /></OptionalAuth>}
        />
      </Routes>
      <Outlet />
    </>
  );
}

export default App;
